
<h1 mat-dialog-title *ngIf="data.title">{{data.title}}</h1>

<div mat-dialog-content>
  <p>
    {{this.message}}
  </p>
</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-raised-button id="dialogConfirmCancelButton"
    *ngIf="buttonCancelLabel"
    color="secondary"
    (click)="onClickCancel()">
    {{this.buttonCancelLabel}}
  </button>
  <button mat-raised-button id="dialogConfirmSuccessButton"
    color="primary"
    (click)="onClickClose()">
    {{this.buttonlabel}}
  </button>
</div>
